// These large barrel exports cause circular dependency issues. We need to avoid using them.
console.warn('Used deprecated barrel export');

/*
 * Public API Surface of suvo-core-client-lib
 */

// Services
export * from './lib/features/auth/services/auth.service';
export * from './lib/suvo-core-client-lib.service';
export * from './lib/shared/services/api/api.service';
export * from './lib/shared/services/common/common.service';

// Modules
export * from './lib/suvo-core-client-lib.module';
export * from './lib/features/common-components/common-components.module';
export * from './lib/features/pipes/pipes.module';

// Components
export * from './lib/features/common-components/components/error-message/error-message.component';
export * from './lib/features/common-components/components/icon-message/icon-message.component';
export * from './lib/features/common-components/components/loading-spinner/loading-spinner.component';
export * from './lib/features/common-components/components/route-toggle-group/route-toggle-group.component';
export * from './lib/features/common-components/components/success-message/success-message.component';

// Models
export * from './lib/shared/models/common/common-model';

/*  Breadcrumbs
 */
export * from './lib/features/breadcrumbs/breadcrumbs.module';
export * from './lib/features/breadcrumbs/components/breadcrumbs/breadcrumbs.component';
export * from './lib/features/breadcrumbs/services/breadcrumbs.service';

/* SEO
 */
export * from './lib/features/seo/services/seo.service';
export * from './lib/features/checklist';

/* Error List
 */
export * from './lib/features/error-list';
